/**
 * Context for service version selection state.
 * Separated to enable React Fast Refresh in components.
 */

import React from "react";
import { ServiceVersionSelectionState } from "./service-version-selection-types";

export const ServiceVersionSelectionStateContext =
  React.createContext<ServiceVersionSelectionState>(
    undefined as unknown as ServiceVersionSelectionState,
  );
